import type { FC } from "react";
import React, { useRef } from "react";

import clsx from "clsx";

import type { AdaptiveSelectorProps } from "@app/components/adaptive-selector-container/types";
import { useClickOutside } from "@app/components/search-form-hydrated/autocomplete-input-hydrated/hooks/use-click-outside";

export const DesktopSelectorContainer: FC<AdaptiveSelectorProps> = ({
  children,
  popover_className,
  ...props
}) => {
  const dropdownRef = useRef<HTMLDivElement>(null);

  useClickOutside([dropdownRef, props.anchor_element], () => {
    if (props.isOpen) {
      props.onClose();
    }
  });

  return (
    <div
      ref={dropdownRef}
      className={clsx(
        "absolute z-[1300] w-[21rem] rounded-lg bg-color-elevation-floating-canvas p-250 shadow-elevation-floating",
        popover_className
      )}
    >
      {children}
    </div>
  );
};
